import React from "react";
import {
  CustomFeedbackOption,
  CustomFeedbackSubOption,
} from "@kahunmedical/common-configuration/dist/configuration/dialogueOptions";
import { styled } from "@mui/material";
import { ReactComponent as CheckCircleIcon } from "fe-web-components/assets/patientCard/checkCircleIcon.svg";
import { ReactComponent as XCircleIcon } from "fe-web-components/assets/patientCard/xCircleIcon.svg";
import { ReactComponent as ThumbsUp } from "fe-web-components/assets/thumbsUpIcon.svg";
import { ReactComponent as ThumbsDown } from "fe-web-components/assets/thumbsDownIcon.svg";

interface FeedbackDisplayProps {
  feedback: {
    positive?: boolean;
    freeText?: string;
    predefinedText?: string;
    customFeedback?: CustomFeedbackOption[];
  };
}

const FeedbackDisplayContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  "& .thumbs-up": {
    width: 17,
    height: 17,
    color: "#1ca21c",
  },
  "& .thumbs-down": {
    width: 17,
    height: 17,
    color: "#ff3b3b",
  },
  "& .check-circle": {
    width: 19,
    height: 19,
    fill: "#1ca21c",
  },
  "& .x-circle": {
    width: 17,
    height: 17,
    fill: "#ff3b3b",
  },
  "& .dataRow": {
    display: "flex",
    gap: 8,
  },
  "& ul": {
    margin: 0,
  },
});

const FeedbackDisplay = ({ feedback }: FeedbackDisplayProps) => {
  return (
    <FeedbackDisplayContainer>
      {feedback?.positive && <ThumbsUp className={"thumbs-up"} />}
      {feedback?.positive === false && <ThumbsDown className={"thumbs-down"} />}
      {feedback.freeText && <div>"{feedback.freeText}"</div>}
      {feedback.predefinedText && <div>{feedback.predefinedText}</div>}
      {feedback.customFeedback && (
        <>
          {feedback.customFeedback.map(
            (cfbk: CustomFeedbackOption) =>
              cfbk.value !== undefined && (
                <React.Fragment key={cfbk.id}>
                  <div className={"dataRow"}>
                    <strong>{cfbk.text}</strong>
                    {cfbk.value ? (
                      <CheckCircleIcon className={"check-circle"} />
                    ) : (
                      <XCircleIcon className={"x-circle"} />
                    )}
                  </div>
                  {cfbk.value && cfbk.subOptionsIfTrue && (
                    <>
                      {cfbk.subTitleIfTrue && (
                        <div className={"subOptionsTitle"}>
                          {cfbk.subTitleIfTrue}
                        </div>
                      )}
                      {cfbk.subOptionsIfTrue.map(
                        (subOption: CustomFeedbackSubOption) => (
                          <div key={subOption.id}>{subOption.text}</div>
                        ),
                      )}
                    </>
                  )}
                  {!cfbk.value && cfbk.subOptionsIfFalse?.length > 0 && (
                    <>
                      {cfbk.subTitleIfFalse && (
                        <div className={"subOptionsTitle"}>
                          {cfbk.subTitleIfFalse}
                        </div>
                      )}
                      <ul>
                        {cfbk.subOptionsIfFalse.map(
                          (subOption: CustomFeedbackSubOption) => (
                            <li key={subOption.id}>{subOption.text}</li>
                          ),
                        )}
                      </ul>
                    </>
                  )}
                </React.Fragment>
              ),
          )}
        </>
      )}
    </FeedbackDisplayContainer>
  );
};

export default FeedbackDisplay;
